import {UIState} from "data/UIState";
import * as React from "react";

import './HRAlert.pcss';
import {observer} from "mobx-react";

export const HRAlert = observer(() => {

  return (
    <div className={`hr-alert ${UIState.hrAlertTitle!==''?'opened':'closed'}`}>
      <div className={"hr-panel"}>
        {UIState.hrPleaseWait ?
            <h1>Please wait...</h1>
        :
            <>
              <h1>{UIState.hrAlertTitle}</h1>
              <p>{UIState.hrAlertDetails}</p>
              <div className={"action"}>
                <button onClick={UIState.hrCloseAlert}>Ok</button>
              </div>
            </>
        }
      </div>
    </div>
  );
});
